export default __webpack_public_path__ + "static/media/autocode.fcd41986.svg";